import type { CashbackFiltersValues } from '../components/CashbackFilters';

function formatLocalYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function getInitialCashbackFilters(): CashbackFiltersValues {
  const end = new Date();
  const start = new Date(end.getTime() - 24 * 60 * 60 * 1000);
  return {
    status: 'unpaid',
    search: '',
    startDate: formatLocalYmd(start),
    endDate: formatLocalYmd(end),
  };
}
